import gql from 'graphql-tag';

export default gql`
  fragment MapFeatureSearchResultFragment on MapPointOfInterestFeature {
    id
    name
    floor {
      id
      name
    }
  }
`;
